export default {
  "shoes": "Zapatos",
  "hoodies": "Sudaderas/Suéteres",
  "tshirts": "Camisetas",
  "jackets": "Chaquetas",
  "pants": "Pantalones/Shorts",
  "headwear": "Gorras y sombreros",
  "sets": "Conjuntos",
  "underwear": "Ropa interior",
  "jersey": "Camisetas deportivas",
  "accessories": "Accesorios",
  "bags": "Bolsos",
  "belts": "Cinturones",
  "perfumes": "Perfumes",
  "other": "Otras cosas",
  "view": "Ver",
  "tag.shoes": "Calzado",
  "tag.hoodies": "Parte superior",
  "tag.tshirts": "Parte superior",
  "tag.jackets": "Abrigos",
  "tag.pants": "Parte inferior",
  "tag.headwear": "Accesorios",
  "tag.sets": "Conjuntos",
  "tag.underwear": "Ropa interior",
  "tag.jersey": "Deporte",
  "tag.accessories": "Extras",
  "tag.bags": "Bolsos",
  "tag.belts": "Accesorios",
  "tag.perfumes": "Fragancias",
  "tag.other": "Más"
};